module.exports = "<div class=\"m-bottom-15 hotel-image-container\" data-slnm-ihg=\"hotelMainPhotoSID\">\n  <span *ngIf='hotelImageUrl'>\n    <div class=\"hotel-image\" [ngStyle]=\"{'background' : 'url(' + hotelImageUrl + ')  no-repeat center center'}\" data-slnm-ihg=\"hotelImageSID\">\n    </div>\n  </span>\n  <div class=\"image-default-svg-box\" [inlineSVG]='\"icon_noImage.svg\"' data-slnm-ihg=\"hotelImageSID\"></div>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/hotel-image/hotel-image.component.html
// module id = ./src/main/webapp/stay-mgmt/app/components/hotel-image/hotel-image.component.html
// module chunks = 0